/**
 * Fixes curly-quote directionality errors common in LLM output.
 *
 * Rule 1 – Apostrophes inside words:
 *   A LEFT SINGLE QUOTATION MARK (\u2018) flanked by word characters
 *   is almost certainly an apostrophe and should be RIGHT (\u2019).
 *   Pattern: (\w)\u2018(\w) → $1\u2019$2
 *
 * Rule 2 – Closing double quote after em dash (interrupted speech):
 *   An em dash (\u2014) followed by LEFT DOUBLE QUOTATION MARK (\u201C)
 *   at the end of a line or string should use RIGHT DOUBLE QUOTATION MARK
 *   (\u201D) — the speech was interrupted mid-sentence, so the quote is
 *   closing. Only applies at line/string boundaries to avoid false
 *   positives when em dash precedes genuinely new dialogue.
 *   Pattern: \u2014\u201C$ → \u2014\u201D (with multiline flag)
 */
export function normalizeQuoteDirection(text: string): string;
export function normalizeQuoteDirection(text: unknown): unknown;
export function normalizeQuoteDirection(text: unknown): unknown {
  if (typeof text !== "string") return text;
  return text
    .replace(/(\w)\u2018(\w)/g, "$1\u2019$2")
    .replace(/\u2014\u201C$/gm, "\u2014\u201D");
}
